import React, { Component } from 'react';
import * as typeformEmbed from '@typeform/embed';
import Fade from 'react-reveal/Fade';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Container,
  Nav,
  Row,
  NavItem,
  Button,
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Media
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import BackgroundSvg from './img/Background4.svg';
import LocalizedLink from '../../../../../components/LocalizedLink';
import platformDashboard from '../../../../../media/platform-tableau-de-bord.png';
import AskForDemoButton from '../../../../../components/Button/AskForDemo';


export default class Header extends Component {
  render() {
    const {
      link,
      locale
    } = this.props;
    return (
      // <div className="header" style={{backgroundImage: `url(${HeaderImageJpg})`}}>
      <div className="header">
        <img className="headerBackground" src={BackgroundSvg} />
        <Container fluid>
          <Row>
            <Col lg={5}>
              <div className="intro-message">
                <Row>
                  <Fade left>
                    <h1 id="title">
                      TriDyme: Portail personnalisé pour <strong>les Ecoles et les Universités du secteur du BTP</strong>.
                    </h1>
                  </Fade>
                </Row>
                <Row>
                  <hr className="spacing" />
                </Row>
                <Row>
                  <Fade left>
                    <h5 id="subtitle">
                      Permettez à vos élèves d'avoir la même qualité de formation y compris en distanciel.
                    </h5>
                  </Fade>
                </Row>
                <Row>
                  <hr className="spacing" />
                </Row>
                <Row>
                  <Col lg={6}>
                    <Fade left>
                      <LocalizedLink className="nav-link" to="/contact/" >
                        <Button
                          className="mainButton"
                          color="primary"
                          size="lg">
                          Nous contacter
                      </Button>
                      </LocalizedLink>
                    </Fade>
                  </Col>
                  <Col lg={6}>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={7}>
              <Fade right>
                <div className="header-image">
                  <img src={platformDashboard} alt="TriDyme Platform" style={{ width: '100%', borderRadius: '8px', boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }} />
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}